import './App.css';
import Calculator from './components/calculator/Calculator';
function App() {
  return (
    <div>
      <Calculator />
    </div>
  );
}

export default App;
